import {
  $AjaxJson
} from '../lf'

import {
  $Urlpath,
  $UrlApipath
} from '../config/config'

export const  RoleRequest = {
      GetRole(func,ID) {
           $AjaxJson($UrlApipath+"Role/GetRole",{ID:ID},function (d) {
                func(d)
           })
      },
      DeleteRole(func,ID) {
          $AjaxJson($UrlApipath+"Role/DeleteRole",{ID:ID},function (d) {
               func(d)
          })
     },
      AddRole(func,obj) {
               $AjaxJson($UrlApipath+"Role/AddRole",obj,function (d) {
                    func(d)
               })
      },
      UpdateRole(func,obj) {
               $AjaxJson($UrlApipath+"Role/UpdateRole",obj,function (d) {
                    func(d)
               })
      },
      SearchRole(func,obj) {
               $AjaxJson($UrlApipath+"Role/SearchRole",obj,function (d) {
                    func(d)
               })
      },
}







// WEBPACK FOOTER //
// ./src/request/RoleRequest.js